// extracted by mini-css-extract-plugin
export default {"inputGroup":"CustomDatePickerOld_inputGroup__ciISi","errorWrap":"CustomDatePickerOld_errorWrap__EMWhZ"};